'use client';

import type React from 'react';
import { useEffect } from 'react';
import { ScrollProvider } from '@/app/_lib/providers/ScrollProvider';
import { ThemeProvider } from '@/app/_lib/providers/ThemeProvider';

interface ProvidersProps {
  children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  // Add metadata references to head when component mounts
  useEffect(() => {
    // Add humans.txt reference if not already present
    if (!document.querySelector('link[rel="author"]')) {
      const authorLink = document.createElement('link');
      authorLink.rel = 'author';
      authorLink.href = '/humans.txt';
      document.head.appendChild(authorLink);
    }

    // Add sitemap reference if not already present
    if (!document.querySelector('link[rel="sitemap"]')) {
      const sitemapLink = document.createElement('link');
      sitemapLink.rel = 'sitemap';
      sitemapLink.type = 'application/xml';
      sitemapLink.href = '/sitemap.xml';
      document.head.appendChild(sitemapLink);
    }
  }, []);

  return (
    <ScrollProvider>
      <ThemeProvider defaultTheme='system' enableSystem={true} storageKey='theme'>
        {children}
      </ThemeProvider>
    </ScrollProvider>
  );
}
